<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="isOnboardingFlow ? '/onboarding/referral' : '/more' "></ion-back-button>
    </ion-buttons>
    <ion-title>Terms of Service</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <div [innerHTML]="termDescription$ | async" class="tw:min-h-full tw:w-full tw:px-4 tw:py-8"></div>
</red-page-content>

@if (this.isOnboardingFlow) {
<red-footer-content>
  <ion-toolbar>
    <ion-buttons class="tw:flex-1 tw:justify-between tw:px-4">
      <ion-button (click)="onDecline()"><ion-icon name="close-circle-outline"></ion-icon>Decline</ion-button>
      <ion-button color="primary" (click)="onAccept()">
        Accept<ion-icon name="checkmark-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-footer-content>
}
